import React from 'react';
import { Button } from '@mui/material';

import styles from './ApiResponseDisplay.module.css';
import buttonStyle from '../../GlobalStyles/button.module.css';


import { useSelector, useDispatch } from '../../redux/store';
import { slice } from '../../redux/slices/dashboard';

const ApiResponseDisplay = ({ apiResponse, setIsResponseShown, onClose }) => {
    const dispatch = useDispatch();

    const getDisplayMessage = (response) => {
        if (typeof response === 'string') {
            return response;
        }
        if (typeof response === 'object' && response !== null) {
            if (response.message) return response.message;
            if (response.error) return response.error;
            return JSON.stringify(response);
        }
        return "An unexpected response format was received.";
    };

    const displayMessage = getDisplayMessage(apiResponse);

    return (
        <div className={styles.Overlay}>
            <div className={styles.ResponseBox}>
                <div
                    style={{
                        fontSize: 16,
                        fontFamily: 'PT Sans',
                        textAlign: 'center',
                        margin: '20px',
                        marginLeft: '25px',
                        marginRight: '25px',
                        whiteSpace: 'pre-wrap',
                        wordBreak: 'break-word'
                    }}
                >
                    {displayMessage}
                </div>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button className={buttonStyle.Button} onClick={() => {
                        if (onClose) onClose();
                        dispatch(slice.actions.hasError(null));
                        setIsResponseShown(false);
                    }}>
                        OK
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default ApiResponseDisplay;
